var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 9.14502L16.6768 6.7319L18.9999 4.72943V9.14502Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32594 6.7319L1 9.14783V4.72943L3.32594 6.7319Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.3388V13.5606C19 14.0978 18.5641 14.5338 18.0269 14.5338H1.97312C1.4359 14.5338 1 14.0979 1 13.5606V11.3388L4.47903 7.72748L8.45312 11.1503C8.86656 11.5047 9.41496 11.7016 10 11.7016C10.585 11.7016 11.1362 11.5047 11.5497 11.1503L15.5209 7.72748L19 11.3388Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.97031V2.94344L10.5118 10.2559C10.239 10.4922 9.7609 10.4922 9.48809 10.2559L1 2.94344V1.97031C1 1.43316 1.43587 1 1.97312 1H18.0269C18.5641 1 19 1.43316 19 1.97031Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7ffea8229f42135771b388bbd96cdd76.svg";
export { ForwardRef as ReactComponent };